/* Exomila · moteur d'animation "Motion made visible" — bulletproof.
   Reveal-on-scroll additif + fail-safe (le contenu ne reste JAMAIS invisible). */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function buildHero() {
    try {
      var ph = document.querySelector('.exo-hero__ph');
      if (!ph || ph.querySelector('.exo-orb')) return;
      var orb = document.createElement('div');
      orb.className = 'exo-orb';
      orb.setAttribute('aria-hidden', 'true');
      orb.innerHTML = '<span class="exo-orb__glow"></span><span class="exo-ring"></span><span class="exo-ring"></span><span class="exo-ring"></span><span class="exo-orb__core"></span>';
      ph.appendChild(orb);
    } catch (e) {}
  }

  var SEL = '.exo-hero__copy > *, .exo-hero__reass, .exo-reass li, .exo-tb__item, section h2, [class*="exo-"] > .exo-eyebrow, [class$="__grid"] > *, [class$="__args"] > *, [class$="__cards"] > *, [class*="card"], [class*="__item"], [class*="__step"], [class*="__benefit"], [class*="__quote"], [class*="__row"], .exo-col__intro';

  function revealAll() {
    document.querySelectorAll('[data-exo-reveal]').forEach(function (el) { el.classList.add('exo-in'); });
  }

  ready(function () {
    buildHero();
    if (reduce || !('IntersectionObserver' in window)) return; // CSS keeps content visible

    var els;
    try { els = document.querySelectorAll(SEL); } catch (e) { return; }

    // tag + stagger (each in its own try so one bad node can't stop the loop)
    Array.prototype.forEach.call(els, function (el) {
      try {
        if (el.hasAttribute('data-exo-reveal') || (el.closest && el.closest('[data-exo-noanim]'))) return;
        el.setAttribute('data-exo-reveal', '');
        var p = el.parentElement;
        if (p) {
          var idx = 0, n = el;
          while ((n = n.previousElementSibling)) { if (n.hasAttribute && n.hasAttribute('data-exo-reveal')) idx++; }
          if (idx > 0) el.style.setProperty('--exo-d', Math.min(idx * 85, 510) + 'ms');
        }
      } catch (e) {}
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('exo-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px 12% 0px', threshold: 0.01 });

    document.querySelectorAll('[data-exo-reveal]').forEach(function (el) {
      try {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 1.05) el.classList.add('exo-in'); // in/near view -> show
        else io.observe(el);
      } catch (e) { el.classList.add('exo-in'); }
    });

    // FAIL-SAFE: nothing stays hidden after 1.6s no matter what
    setTimeout(revealAll, 1600);
    // extra safety on load + a scroll fallback
    window.addEventListener('load', function () { setTimeout(revealAll, 300); });

    var onScroll = function () {
      document.documentElement.classList.toggle('exo-scrolled', window.scrollY > 20);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    // Hero product reacts to scroll: parallax + subtle tilt ("turns toward you")
    try {
      var hero = document.querySelector('.exo-hero');
      var himg = document.querySelector('.exo-hero__img');
      var mv = document.querySelector('.exo-hero__model');
      if (hero && (himg || mv)) {
        var ticking = false;
        var applyHero = function () {
          ticking = false;
          var r = hero.getBoundingClientRect();
          var vh = window.innerHeight;
          // progress 0 (hero entering bottom) -> 1 (hero leaving top)
          var p = 1 - (r.bottom) / (vh + r.height);
          p = Math.max(0, Math.min(1, p));
          if (mv) {
            // true 3D: rotate the model on scroll (a ~200deg sweep)
            var az = -40 + p * 200;
            mv.setAttribute('camera-orbit', az.toFixed(1) + 'deg 82deg 110%');
            return;
          }
          var ty = (p - 0.5) * 40;          // parallax
          var ry = (p - 0.5) * 18;          // subtle turn, max ~9deg each way
          var sc = 1 + (1 - Math.abs(p - 0.5) * 2) * 0.04;
          himg.style.transform = 'translateY(' + ty.toFixed(1) + 'px) rotateY(' + ry.toFixed(1) + 'deg) scale(' + sc.toFixed(3) + ')';
        };
        var onHeroScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(applyHero); } };
        window.addEventListener('scroll', onHeroScroll, { passive: true });
        window.addEventListener('resize', onHeroScroll, { passive: true });
        applyHero();
      }
    } catch (e) {}

    document.addEventListener('shopify:section:load', function (e) {
      buildHero();
      try {
        var nw = e.target.querySelectorAll(SEL);
        Array.prototype.forEach.call(nw, function (el) { el.setAttribute('data-exo-reveal', ''); el.classList.add('exo-in'); });
      } catch (err) {}
    });
  });
})();
